import React from 'react';
import Icon from '@/components/ui/AppIcon';

interface ImplementationPhaseCardProps {
  phase: string;
  duration: string;
  description: string;
  keyActivities: string[];
  deliverables: string[];
}

const ImplementationPhaseCard = ({ 
  phase, 
  duration, 
  description, 
  keyActivities, 
  deliverables 
}: ImplementationPhaseCardProps) => {
  return (
    <div className="bg-card rounded-lg p-6 shadow-subtle border border-border">
      <div className="flex items-start justify-between mb-4">
        <div>
          <h3 className="text-xl font-display font-semibold text-foreground mb-1">
            {phase}
          </h3>
          <div className="flex items-center space-x-2 text-sm text-muted-foreground">
            <Icon name="ClockIcon" size={16} />
            <span>{duration}</span>
          </div>
        </div>
      </div>
      
      <p className="text-muted-foreground mb-4">
        {description}
      </p>
      
      <div className="space-y-4">
        <div>
          <div className="text-sm font-semibold text-foreground mb-2 flex items-center space-x-2">
            <Icon name="ListBulletIcon" size={16} className="text-primary" />
            <span>Key Activities:</span>
          </div>
          <ul className="space-y-1 ml-6">
            {keyActivities.map((activity, index) => (
              <li key={index} className="text-sm text-muted-foreground list-disc">
                {activity}
              </li>
            ))}
          </ul>
        </div>
        
        <div>
          <div className="text-sm font-semibold text-foreground mb-2 flex items-center space-x-2">
            <Icon name="CheckBadgeIcon" size={16} className="text-success" />
            <span>Deliverables:</span>
          </div>
          <ul className="space-y-1 ml-6">
            {deliverables.map((deliverable, index) => (
              <li key={index} className="text-sm text-muted-foreground list-disc">
                {deliverable}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ImplementationPhaseCard;